import { BaseModel, Default } from '@red/data-access';
import { Expose, Type } from 'class-transformer';
import { EEcddTransactionType } from '../enums/ecdd.enum';
import { IEcddCheckList } from '../interfaces/ecdd.interface';
import { EcddOptionGroupModel } from './ecdd-option-group.model';

export class EcddChecklistModel extends BaseModel implements IEcddCheckList {
  @Expose()
  id!: number;

  @Expose()
  type!: EEcddTransactionType;

  @Expose()
  isDefault!: boolean;

  @Expose()
  isActive!: boolean;

  @Expose()
  @Default([])
  @Type(() => EcddOptionGroupModel)
  checklistOptionGroups!: EcddOptionGroupModel[];
}

export class CheckListFormModel extends BaseModel {
  @Expose() personal_saving?: string;
  @Expose() sale_of_property?: string;
  @Expose() business_income?: string;
  @Expose() investment_returns?: string;
  @Expose() loan_bank_institution?: string;
  @Expose() cpf_funds?: string;
  @Expose() gift_inheritance?: string;
  @Expose() others_checkbox_1?: string;
  @Expose() bank_statements?: string;
  @Expose() cpf_statement?: string;
  @Expose() sale_purchase_agreement_previous_property?: string;
  @Expose() loan_approval_letter?: string;
  @Expose() investment_portfolio_statements?: string;
  @Expose() gift_deed_inheritance_documents?: string;
  @Expose() others_checkbox_2?: string;
  @Expose() business_ownership?: string;
  @Expose() employment_income?: string;
  @Expose() investments?: string;
  @Expose() inheritance?: string;
  @Expose() property_portfolio?: string;
  @Expose() others_checkbox_3?: string;
  @Expose() company_financial_statements?: string;
  @Expose() employment_letter_pay_slips?: string;
  @Expose() tax_returns?: string;
  @Expose() investment_certificates?: string;
  @Expose() property_ownership_documents?: string;
  @Expose() others_checkbox_4?: string;
  @Expose() sales_purchase_price?: string;
  @Expose() monthly_rental_amount?: string;
  @Expose() propose_of_transaction?: string;
  @Expose() please_specify_propose_of_transaction?: string;
  @Expose() total_transaction_amount_in_numeral?: string;
  @Expose() bank_institution_name?: string;
  @Expose() others_1?: string;
  @Expose() no_of_months_bank_statements?: string;
  @Expose() others_2?: string;
  @Expose() estimated_total_net_worth_in_numeral?: string;
  @Expose() primary_client_company_name?: string;
  @Expose() investment_type?: string;
  @Expose() others_3?: string;
  @Expose() others_4?: string;
  @Expose() basis_for_high_risk_rating?: string;
  @Expose() recommended_not_recommended_to_proceed?: string;
  @Expose() reasons_for_accepting_high_risk_client?: string;
  @Expose() approved_not_approved?: string;
  @Expose() approving_officer_name?: string;
  @Expose() approving_officer_designation?: string;
  @Expose() yes_no_please_specify_reasons?: string;
  @Expose() others_5?: string;
  @Expose() sign_date?: string; // Use Date if you want: @Type(() => Date)
  @Expose() signature?: string;
}